import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=b8fb922c&scoped=true&"
import script from "./Funds.vue?vue&type=script&lang=js&"
export * from "./Funds.vue?vue&type=script&lang=js&"
import style0 from "./Funds.vue?vue&type=style&index=0&id=b8fb922c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fb922c",
  null
  
)

export default component.exports